<template>
  <div>
    <h3>Documents</h3>
    <hr>
    <button v-if="editAccess" class="mylisting-button dark-button mb-3" @click="showUploadDocumentsModal()">
      Upload Documents
    </button>
    <!-- <p>{{ user.resume }}</p> -->
    <div class="row">
      <div class="col-lg-4" v-if="user.resume">
        <div class="center py-4 mb-3" style="border: 1px solid var(--bootstrapgrey); border-radius: 3px;">
          <h5 class="mb-3">Resume</h5>

            <a style="color: white;" :href="user.resume" target="_blank"><button class="mylisting-button dark-button">View</button></a>


          <!-- <h5 class="mb-3"><a class="" :href="user.resume" target="_blank">Resume</a></h5> -->
        </div>
      </div>
      <div class="col-lg-4" v-if="user.file1">
        <div class="center py-4 mb-3" style="border: 1px solid var(--bootstrapgrey); border-radius: 3px;">
          <h5 class="mb-3">Letter of Recommendation</h5>
          <a style="color: white;" :href="user.file1" target="_blank"><button class="mylisting-button dark-button">View</button></a>
        </div>
      </div>
      <div class="col-lg-4" v-if="user.file3">
        <div class="center py-4 mb-3" style="border: 1px solid var(--bootstrapgrey); border-radius: 3px;">
          <h5 class="mb-3">Letter of Recommendation 2</h5>
          <a style="color: white;" :href="user.file3" target="_blank"><button class="mylisting-button dark-button">View</button></a>
        </div>
      </div>
      <div class="col-lg-4" v-if="user.file4">
        <div class="center py-4 mb-3" style="border: 1px solid var(--bootstrapgrey); border-radius: 3px;">
          <h5 class="mb-3">Letter of Recommendation 3</h5>
          <a style="color: white;" :href="user.file4" target="_blank"><button class="mylisting-button dark-button">View</button></a>
        </div>
      </div>
      <div class="col-lg-4" v-if="user.file2 && editAccess">
        <div class="center py-4 mb-3" style="border: 1px solid var(--bootstrapgrey); border-radius: 3px;">
          <h5 class="mb-3">Government ID</h5>

            <a style="color: white;" :href="user.file2" target="_blank"><button class="mylisting-button dark-button">View</button></a>

          <!-- <h5 class="mb-3"><a class="" :href="user.resume" target="_blank">Resume</a></h5> -->
        </div>
      </div>
    </div>

    <div v-if="editAccess" class="row">
      <div v-for="document in documents" :key="document.id" class="col-lg-4">
        <div class="center py-4 mb-3" style="border: 1px solid var(--bootstrapgrey); border-radius: 3px;">
          <h5 class="mb-3">{{ document.title }}<span v-if="document.status == 'Signed'"><i style="font-size: 11px; margin-left: 5px; color: #444;" class="material-icons mt-1">check_circle</i></span></h5>
          <button v-if="document.title == 'Code of Conduct' && document.status == 'Unsigned'" class="mylisting-button dark-button" @click="showCodeOfConductModal(document)">Sign</button>
          <button v-if="document.title == 'Code of Conduct' && document.status == 'Signed'" class="mylisting-button dark-button" @click="showCodeOfConductModal(document)">View</button>
          <button v-if="document.title == 'Background Check' && document.status == 'Unsigned'" class="mylisting-button dark-button" @click="showBackgroundCheckModal(document)">Sign</button>
          <button v-if="document.title == 'Background Check' && document.status == 'Signed'" class="mylisting-button dark-button" @click="showBackgroundCheckModal(document)">View</button>

          <!-- <button class="mylisting-button danger-button" @click="deleteDocument(document)">Delete</button> -->
          <!-- <button class="mylisting-button danger-button" @click="unsignDocument(document)">Unsign</button> -->
        </div>
      </div>
    </div>

    <modal name="code-of-conduct-modal" width="80%" height="auto" :scrollable='true' style="z-index: 9999;">
      <div class="p-5" v-if="user.id">
        <code-of-conduct :user="user" :document="document" @documentSigned="documentSigned()"></code-of-conduct>
        <hr>
        <button class="mylisting-button secondary-button" @click="$modal.hide('code-of-conduct-modal')">Close</button>
      </div>
    </modal>

    <modal name="background-check-modal" width="80%" height="auto" :scrollable='true' style="z-index: 9999;">
      <div class="p-5" v-if="user.id">
        <background-check :user="user" :document="document" @documentSigned="documentSigned()"></background-check>
        <hr>
        <button class="mylisting-button secondary-button" @click="$modal.hide('background-check-modal')">Close</button>
      </div>
    </modal>

    <modal name="document-signed-modal" width="80%" height="auto" :scrollable='true' style="z-index: 9999;">
      <div class="p-5">
        <h2>Your document has been signed.</h2>
        <hr>
        <button class="mylisting-button secondary-button" @click="$modal.hide('document-signed-modal')" style="">Close</button>
      </div>
    </modal>

    <modal name="upload-documents-modal" width="80%" height="auto" :scrollable='true' style="z-index: 9999;">
      <div class="p-5">
        <h2>Upload Documents</h2>
        <hr>
        <!-- <p>You don't need to upload them all at once.</p> -->
        <div class="">
          <!-- <hr v-if="user.status == 'Hiring in Process' || user.status == 'Hired'"> -->
          <div class="row mb-4">
            <div class="col-lg-4">
              <label style="">Resume</label>
              <input type="file" class="form-control-file" style="font-size: 0.8rem;" id="resume" ref="resume" v-on:change="handleFileUpload()"/>
            </div>
            <div class="col-lg-4">
              <label style="">Letter of Recommendation</label>
              <input type="file" class="form-control-file" style="font-size: 0.8rem;" id="file1" ref="file1" v-on:change="handleFileUpload()"/>
            </div>
            <div class="col-lg-4">
              <label style="">Letter of Recommendation 2</label>
              <input type="file" class="form-control-file" style="font-size: 0.8rem;" id="file3" ref="file3" v-on:change="handleFileUpload()"/>
            </div>
            <div class="col-lg-4">
              <label style="">Letter of Recommendation 3</label>
              <input type="file" class="form-control-file" style="font-size: 0.8rem;" id="file4" ref="file4" v-on:change="handleFileUpload()"/>
            </div>
            <div class="col-lg-4">
              <label style="">Government ID</label>
              <input type="file" class="form-control-file" style="font-size: 0.8rem;" id="file2" ref="file2" v-on:change="handleFileUpload()"/>
            </div>
          </div>

        </div>
        <hr>
        <button class="mylisting-button secondary-button" @click="$modal.hide('upload-documents-modal')" style="">Close</button>
        <button class="mylisting-button dark-button" style="float: right;" @click="uploadDocuments()">Upload</button>
      </div>
    </modal>

    <modal name="documents-uploaded-modal" width="80%" height="auto" :scrollable='true' style="z-index: 9999;">
      <div class="p-5">
        <h2>Documents uploaded.</h2>
        <p>It could take a few seconds for them to process, if they don't update right away try refreshing in a minute!</p>
        <hr>
        <button class="mylisting-button secondary-button" @click="$modal.hide('documents-uploaded-modal')" style="">Close</button>
      </div>
    </modal>

  </div>
</template>

<script>
import axios from 'axios'

import CodeOfConduct from '../documents/CodeOfConduct'
import BackgroundCheck from '../documents/BackgroundCheck'

export default {
  props: ['user'],
  components: {
    CodeOfConduct,
    BackgroundCheck,
  },
  computed: {
    editAccess() {
      if (this.user.id == this.$store.getters.userID || this.$store.getters.isAgent === true) {
        return true
      } else {
        return false
      }
    },
    viewOnlyAccess() {
      if (this.$store.getters.isEmployer === true) {
        return true
      } else {
        return false
      }
    }
  },
  data() {
    return {
      documents: [],
      document: {},
    }
  },
  created() {
    this.getDocuments()
  },
  methods: {
    getDocuments() {
      axios.get(`/api/documents/?signing_user=${this.user.id}`)
        .then(res => {
          console.log(res)
          this.documents = res.data
          this.documents = this.documents.sort((a, b) => (a.id > b.id) ? 1 : -1)
        })
    },
    showCodeOfConductModal(document) {
      this.document = document
      this.$modal.show('code-of-conduct-modal')
    },
    showBackgroundCheckModal(document) {
      this.document = document
      this.$modal.show('background-check-modal')
    },
    documentSigned() {
      this.getDocuments()
      this.$modal.hide('code-of-conduct-modal')
      this.$modal.hide('background-check-modal')
      this.$modal.show('document-signed-modal')

      this.$store.dispatch('sendEmails',
        {
          subject: `Document Signed - ${this.user.first_name} ${this.user.last_name} | ${this.document.title}`,
          message: 'Hello,' + '\n\n' +
          `The candidate ${this.user.first_name} ${this.user.last_name} just signed the following document: ${this.document.title}\n\n`+
          'Cheers!',
          from: this.$store.getters.agencyFromEmail,
          // emails: [this.$store.getters.enginehireAdminEmail],
          // emails: [this.$store.getters.enginehireAdminEmail, this.$store.getters.agencyAdminEmail, this.$store.getters.agencyAdminEmail2],
          emails: [this.$store.getters.enginehireLoggingEmail, this.$store.getters.agencyAdminEmail, this.$store.getters.agencyAdminEmail2],
          reply: this.$store.getters.agencyReplyEmail,
          // userID: this.aakashid,
          userID: 4,
        }
      )
    },
    showUploadDocumentsModal() {
      this.$modal.show('upload-documents-modal')
    },
    handleFileUpload() {
      this.resume = this.$refs.resume.files[0];
      this.file1 = this.$refs.file1.files[0];
      this.file2 = this.$refs.file2.files[0];
      this.file3 = this.$refs.file3.files[0];
      this.file4 = this.$refs.file4.files[0];
    },
    uploadDocuments() {
      let formData = new FormData();
      if (this.resume) {
        formData.append("resume", this.resume);
      }
      if (this.file1) {
        formData.append("file1", this.file1);
      }
      if (this.file2) {
        formData.append("file2", this.file2);
      }
      if (this.file3) {
        formData.append("file3", this.file3);
      }
      if (this.file4) {
        formData.append("file4", this.file4);
      }

      this.$modal.hide('upload-documents-modal')
      this.$modal.show('documents-uploaded-modal')

      axios.patch("/api/people/".concat(this.user.id.toString()).concat("/"),
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data"
            }
          }
        )
        .then(res => {
          // console.log(res);
          // this.$modal.hide('upload-documents-modal')
          // this.$modal.show('documents-uploaded-modal')
          this.$emit('infoSaved')

          // this.$store.dispatch('sendEmails',
          //   {
          //     subject: `Employment Documents Uploaded - ${this.user.first_name} ${this.user.last_name}`,
          //     message: 'Hello,' + '\n\n' +
          //     `The nanny ${this.user.first_name} ${this.user.last_name} just uploaded new employment documents!\n\n`+
          //     'Cheers!',
          //     from: this.$store.getters.agencyFromEmail,
          //     // emails: [this.$store.getters.enginehireAdminEmail, agencyEmail],
          //     // emails: [this.$store.getters.enginehireAdminEmail],
          //     emails: [this.$store.getters.enginehireAdminEmail, this.$store.getters.agencyAdminEmail4],
          //     reply: this.$store.getters.agencyReplyEmail,
          //     // userID: this.aakashid,
          //     userID: 4,
          //   }
          // )
        })
        .catch(error => {
          console.log(error)
        })
    },


    deleteDocument(document) {
      axios.delete(`/api/documents/${document.id}/`)
        .then(res => {
          this.getDocuments()
        })
        .catch(error => console.log(error))
    },
    unsignDocument(document) {
      axios.patch(`/api/documents/${document.id}/`, {
        status: 'Unsigned',
        signing_name: '',
      })
        .then(res => {
          this.getDocuments()
        })
        .catch(error => console.log(error))
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/components/candidates/profile/Documents.vue